(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Count up numeric stat values when scrolled into view. Non-numeric values
    // (e.g. "P.J.Dip") have no digit match and are left untouched.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

    function animate(el) {
      var m = el.textContent.trim().match(/^(\D*?)([\d,]*\d)(\D*)$/);
      if (!m) return;
      var prefix = m[1];
      var suffix = m[3];
      var hasComma = m[2].indexOf(',') !== -1;
      var target = parseInt(m[2].replace(/,/g, ''), 10);
      if (isNaN(target)) return;
      var start = null;
      var dur = 1200;
      function fmt(n) { return hasComma ? n.toLocaleString('en-US') : String(n); }
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + fmt(Math.round(target * eased)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { animate(entries[i].target); io.unobserve(entries[i].target); }
      }
    }, { threshold: 0.4 });

    var vals = document.querySelectorAll('.careers-stats__value');
    for (var i = 0; i < vals.length; i++) io.observe(vals[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(root) {
      var lists = root.querySelectorAll ? root.querySelectorAll('.about-timeline') : [];
      for (var k = 0; k < lists.length; k++) {
        var section = lists[k];
        var items = section.querySelectorAll('.about-timeline__item[data-at-reveal]');
        if (!items.length) continue;
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          // No observer / reduced motion: leave items visible (hidden state is gated on .is-reveal-ready).
          continue;
        }
        section.classList.add('is-reveal-ready');
        var io = new IntersectionObserver(function (entries, obs) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { entries[i].target.classList.add('is-visible'); obs.unobserve(entries[i].target); }
          }
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        for (var j = 0; j < items.length; j++) io.observe(items[j]);
      }
    }
    if (document.readyState !== 'loading') { reveal(document); }
    else { document.addEventListener('DOMContentLoaded', function () { reveal(document); }); }
    // Theme editor: reveal items in a freshly loaded section.
    document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-form"] && !Shopify.designMode) return;
  try {
    
  for (const form of document.querySelectorAll('[data-section-type="careers-form"] .careers-form__form')) {
    const btn = form.querySelector('.careers-form__submit');
    // Guard double-submit; re-enable if native validation blocks the submit.
    form.addEventListener('submit', () => { if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; } });
    form.addEventListener('invalid', () => { if (btn) { btn.disabled = false; btn.style.opacity = ''; } }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-jobs"] && !Shopify.designMode) return;
  try {
    
  // Attaches listeners by querying the DOM, so wait until the section HTML exists.
  // The section JS bundle can run before the markup is parsed.
  function careersJobsInit() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const modal = document.querySelector('[data-careers-modal]');

    // Grid view: clicking a card shows its full info in the shared modal.
    const openModal = (details, panel) => {
      if (!modal) return;
      const body = modal.querySelector('[data-careers-modal-body]');
      body.innerHTML = '';
      const title = details.querySelector('.careers-job__title');
      if (title) body.appendChild(title.cloneNode(true));
      const inner = panel.querySelector('.careers-job__panel-inner');
      if (inner) body.appendChild(inner.cloneNode(true));
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    };

    // Rows view: height-animate the <details>. Native toggle still works without JS.
    const animateToggle = (details, summary, panel) => {
      let animating = false;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (animating) return;
        animating = true;
        const end = (openState) => {
          const done = (e) => {
            if (e.propertyName !== 'height') return;
            panel.style.height = '';
            if (!openState) details.open = false;
            animating = false;
            panel.removeEventListener('transitionend', done);
          };
          panel.addEventListener('transitionend', done);
        };
        if (!details.open) {
          details.open = true;
          const target = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(() => { panel.style.height = target + 'px'; });
          end(true);
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(() => { panel.style.height = '0px'; });
          end(false);
        }
      });
    };

    for (const list of document.querySelectorAll('[data-section-type="careers-jobs"] .careers-jobs__list')) {
      const isGrid = list.classList.contains('careers-jobs__list--grid');
      for (const details of list.querySelectorAll('.careers-job__details')) {
        const summary = details.querySelector('.careers-job__summary');
        const panel = details.querySelector('.careers-job__panel');
        if (!summary || !panel) continue;
        if (isGrid && modal) {
          summary.addEventListener('click', (event) => { event.preventDefault(); openModal(details, panel); });
        } else if (!reduceMotion) {
          animateToggle(details, summary, panel);
        }
      }

      // Show-more: reveal overflow roles (progressive enhancement; without JS all roles show).
      const perPage = Number(list.dataset.perPage || 0);
      if (perPage > 0 && list.querySelector('.careers-job--overflow')) {
        const more = list.parentElement.querySelector('[data-careers-more]');
        if (more) {
          list.classList.add('is-collapsed');
          more.hidden = false;
          more.querySelector('.careers-jobs__more-btn').addEventListener('click', () => {
            list.classList.remove('is-collapsed');
            more.remove();
          });
        }
      }

      // Store/location filter chips (built from the roles' data-filter values).
      if (list.dataset.filters === 'true') {
        const bar = list.parentElement.querySelector('[data-careers-filters]');
        if (bar) {
          const cards = [...list.querySelectorAll('.careers-job[data-filter]')];
          const values = [...new Set(cards.map((c) => c.dataset.filter).filter(Boolean))].sort();
          if (values.length > 1) {
            const make = (label, value) => {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'careers-jobs__chip';
              b.textContent = label;
              b.dataset.value = value;
              return b;
            };
            const chips = [make(bar.dataset.allLabel || 'All', '')].concat(values.map((v) => make(v, v)));
            chips.forEach((c) => bar.appendChild(c));
            chips[0].classList.add('is-active');
            bar.hidden = false;
            bar.addEventListener('click', (event) => {
              const chip = event.target.closest('.careers-jobs__chip');
              if (!chip) return;
              chips.forEach((c) => c.classList.toggle('is-active', c === chip));
              const v = chip.dataset.value;
              list.classList.remove('is-collapsed');
              const more = list.parentElement.querySelector('[data-careers-more]');
              if (more) more.hidden = true;
              for (const card of cards) {
                card.style.display = (!v || card.dataset.filter === v) ? '' : 'none';
              }
            });
          }
        }
      }
    }

    if (modal) {
      const close = () => { if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open'); };
      modal.querySelector('[data-careers-modal-close]')?.addEventListener('click', close);
      // Close on backdrop click or when an apply link inside is clicked (it scrolls to the form).
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('[data-careers-apply]')) close();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', careersJobsInit);
  } else {
    careersJobsInit();
  }

  // Apply buttons fill the target form, then scroll to it:
  //  - store select  -> the role's store (a native change event lets the form app fill its own store-email field)
  //  - role field    -> the role title
  //  - timestamp     -> dd/mm/yyyy hh:mm (optional)
  // Each field is a configurable CSS selector, looked up inside the scroll target first, then the page.
  // Ids that start with a digit (e.g. #166661-select-1) aren't valid CSS, so they are retried as [id="..."].
  // Without JS the link still scrolls natively via its #hash.
  const careersQuery = (root, selector) => {
    if (!selector) return null;
    for (const sel of [selector, selector.replace(/#([^\s.#\[\]:>+~,]+)/g, '[id="$1"]')]) {
      try {
        const el = root.querySelector(sel);
        if (el) return el;
      } catch (error) { /* invalid selector, try the escaped form */ }
    }
    return null;
  };
  const careersFire = (el) => {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-careers-apply]');
    if (!link) return;
    const section = link.closest('[data-section-type="careers-jobs"]');
    const cfg = (section && section.dataset) || {};
    const storeSel = cfg.storeSelect || '[name="contact[Store]"]';
    const roleSel = cfg.roleField || '[name="contact[Role]"]';

    let target = null;
    if (cfg.scrollTarget) {
      target = careersQuery(document, cfg.scrollTarget);
    } else if (link.hash && link.origin === window.location.origin && link.pathname === window.location.pathname) {
      target = document.getElementById(link.hash.slice(1));
    }
    const find = (selector) => careersQuery(target || document, selector) || careersQuery(document, selector);

    const { store, role } = link.dataset;
    const storeField = find(storeSel);
    if (storeField && store) {
      if (storeField.tagName === 'SELECT' && !Array.from(storeField.options).some((o) => o.value === store)) {
        storeField.append(new Option(store, store));
      }
      storeField.value = store;
      careersFire(storeField);
    } else if (storeField && storeField.tagName === 'SELECT') {
      storeField.value = ''; // role has no store: don't keep the previous role's choice
      careersFire(storeField);
    }

    const roleField = find(roleSel);
    if (roleField) {
      roleField.value = role || '';
      careersFire(roleField);
    }

    const stampField = find(cfg.timestampField);
    if (stampField) {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      stampField.value = pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
      careersFire(stampField);
    }

    const note = (target || document).querySelector('[data-careers-role-note]');
    if (note) {
      note.textContent = role ? note.dataset.prefix + ' ' + role : '';
      note.hidden = !role;
    }

    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-jobs3"] && !Shopify.designMode) return;
  try {
    
  // Attaches listeners by querying the DOM, so wait until the section HTML exists.
  // The section JS bundle can run before the markup is parsed.
  function careers3Init() {
    const sectionOf = (el) => el.closest('[data-section-type="careers3-jobs"]');
    const formTiming = (el) => sectionOf(el)?.dataset.formTiming;
    // Per-job form: fill Store / Role / timestamp inside THIS job's form only.
    const prefill = (inner) => {
      const form = inner.querySelector('[data-careers3-form]');
      const sec = sectionOf(inner) || sectionOf(home?.panel || inner);
      if (!form || !sec) return;
      careers3Prepare(sec, form);
    };
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const modal = document.querySelector('[data-careers3-modal]');

    // Grid view: clicking a card shows its full info in the shared modal.
    // The real panel content is MOVED into the modal (not cloned) so per-job forms keep their scripts/state.
    let home = null;
    const openModal = (details, panel) => {
      if (!modal) return;
      restore(); // put any previous job's panel back before the body is cleared
      const body = modal.querySelector('[data-careers3-modal-body]');
      body.innerHTML = '';
      const title = details.querySelector('.careers3-job__title');
      if (title) body.appendChild(title.cloneNode(true));
      const inner = panel.querySelector('.careers3-job__panel-inner');
      if (inner) { body.appendChild(inner); home = { panel, inner }; prefill(inner); }
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    };
    const restore = () => {
      if (!home) return;
      // on_apply: hide the form again so the next open starts clean.
      const f = home.inner.querySelector('[data-careers3-form]');
      if (f && formTiming(home.inner) === 'on_apply') {
        f.hidden = true;
        const b = home.inner.querySelector('[data-careers3-reveal]');
        if (b) b.hidden = false;
      }
      careers3Detach(home.inner);
      home.panel.appendChild(home.inner);
      home = null;
    };

    // Rows view: height-animate the <details>. Native toggle still works without JS.
    const animateToggle = (details, summary, panel) => {
      let animating = false;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (animating) return;
        animating = true;
        const end = (openState) => {
          const done = (e) => {
            if (e.propertyName !== 'height') return;
            panel.style.height = '';
            if (!openState) details.open = false;
            animating = false;
            panel.removeEventListener('transitionend', done);
          };
          panel.addEventListener('transitionend', done);
        };
        if (!details.open) {
          details.open = true;
          const target = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(() => { panel.style.height = target + 'px'; });
          end(true);
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(() => { panel.style.height = '0px'; });
          end(false);
        }
      });
    };

    for (const list of document.querySelectorAll('[data-section-type="careers3-jobs"] .careers3-jobs__list')) {
      const isGrid = list.dataset.detail === 'modal';
      for (const details of list.querySelectorAll('.careers3-job__details')) {
        const summary = details.querySelector('.careers3-job__summary');
        const panel = details.querySelector('.careers3-job__panel');
        if (!summary || !panel) continue;
        // Expand mode + "show form straight away": fill when the row opens.
        details.addEventListener('toggle', () => {
          if (!details.open) careers3Detach(details);
          const inner = panel.querySelector('.careers3-job__panel-inner');
          if (details.open && inner && formTiming(details) === 'immediate') prefill(inner);
        });
        if (isGrid && modal) {
          summary.addEventListener('click', (event) => { event.preventDefault(); openModal(details, panel); });
        } else if (!reduceMotion) {
          animateToggle(details, summary, panel);
        }
      }

      // Show-more: reveal overflow roles (progressive enhancement; without JS all roles show).
      const perPage = Number(list.dataset.perPage || 0);
      if (perPage > 0 && list.querySelector('.careers3-job--overflow')) {
        const more = list.parentElement.querySelector('[data-careers3-more]');
        if (more) {
          list.classList.add('is-collapsed');
          more.hidden = false;
          more.querySelector('.careers3-jobs__more-btn').addEventListener('click', () => {
            list.classList.remove('is-collapsed');
            more.remove();
          });
        }
      }

      // Store/location filter chips (built from the roles' data-filter values).
      if (list.dataset.filters === 'true') {
        const bar = list.parentElement.querySelector('[data-careers3-filters]');
        if (bar) {
          const cards = [...list.querySelectorAll('.careers3-job[data-filter]')];
          const values = [...new Set(cards.map((c) => c.dataset.filter).filter(Boolean))].sort();
          if (values.length > 1) {
            const make = (label, value) => {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'careers3-jobs__chip';
              b.textContent = label;
              b.dataset.value = value;
              return b;
            };
            const chips = [make(bar.dataset.allLabel || 'All', '')].concat(values.map((v) => make(v, v)));
            chips.forEach((c) => bar.appendChild(c));
            chips[0].classList.add('is-active');
            bar.hidden = false;
            bar.addEventListener('click', (event) => {
              const chip = event.target.closest('.careers3-jobs__chip');
              if (!chip) return;
              chips.forEach((c) => c.classList.toggle('is-active', c === chip));
              const v = chip.dataset.value;
              list.classList.remove('is-collapsed');
              const more = list.parentElement.querySelector('[data-careers3-more]');
              if (more) more.hidden = true;
              for (const card of cards) {
                card.style.display = (!v || card.dataset.filter === v) ? '' : 'none';
              }
            });
          }
        }
      }
    }

    if (modal) {
      const close = () => { if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open'); };
      modal.querySelector('[data-careers3-modal-close]')?.addEventListener('click', close);
      // Close on backdrop click or when an apply link inside is clicked (it scrolls to the form).
      // The dialog 'close' event is not reliable everywhere: also watch the open attribute.
      modal.addEventListener('close', restore);
      new MutationObserver(() => { if (!modal.open) restore(); }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('[data-careers3-apply]')) close();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', careers3Init);
  } else {
    careers3Init();
  }

  // Apply buttons fill the target form, then scroll to it:
  //  - store select  -> the role's store (a native change event lets the form app fill its own store-email field)
  //  - role field    -> the role title
  //  - timestamp     -> dd/mm/yyyy hh:mm (optional)
  // Each field is a configurable CSS selector, looked up inside the scroll target first, then the page.
  // Ids that start with a digit (e.g. #166661-select-1) aren't valid CSS, so they are retried as [id="..."].
  // Without JS the link still scrolls natively via its #hash.
  const careers3Query = (root, selector) => {
    if (!selector) return null;
    for (const sel of [selector, selector.replace(/#([^\s.#\[\]:>+~,]+)/g, '[id="$1"]')]) {
      try {
        const el = root.querySelector(sel);
        if (el) return el;
      } catch (error) { /* invalid selector, try the escaped form */ }
    }
    return null;
  };
  const careers3Fire = (el) => {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // "Reuse page form": the live page form (e.g. .careers2-meet__form) is MOVED into the job's form slot,
  // never cloned, so its event listeners / phone validation stay alive. It goes back when the job closes.
  let careers3Home = null;
  function careers3Detach(within) {
    if (!careers3Home || (within && !within.contains(careers3Home.node))) return;
    const { node, parent, next } = careers3Home;
    parent.insertBefore(node, next && next.parentNode === parent ? next : null);
    careers3Home = null;
  }
  function careers3Prepare(sec, form) {
    if (!sec || !form) return;
    if (form.dataset.source === 'page') {
      if (form.hidden) return;
      if (!form.contains(careers3Home?.node)) {
        careers3Detach();
        const node = careers3Query(document, sec.dataset.formSelector || '.careers2-meet__form');
        if (!node || sec.contains(node)) return;
        careers3Home = { node, parent: node.parentNode, next: node.nextSibling };
        form.appendChild(node);
      }
    }
    careers3Fill(sec.dataset, form, form.dataset.store, form.dataset.role, false);
  }

  // Fills store / role / timestamp. root = where to look first; fallbackDoc = also search the whole page.
  function careers3Fill(cfg, root, store, role, fallbackDoc) {
    const find = (selector) => careers3Query(root, selector) || (fallbackDoc ? careers3Query(document, selector) : null);
    const storeField = find(cfg.storeSelect || '[name="contact[Store]"]');
    if (storeField && store) {
      if (storeField.tagName === 'SELECT' && !Array.from(storeField.options).some((o) => o.value === store)) {
        storeField.append(new Option(store, store));
      }
      storeField.value = store;
      careers3Fire(storeField);
    } else if (storeField && storeField.tagName === 'SELECT') {
      storeField.value = ''; // role has no store: don't keep the previous role's choice
      careers3Fire(storeField);
    }
    const roleField = find(cfg.roleField || '[name="contact[Role]"]');
    if (roleField) {
      roleField.value = role || '';
      careers3Fire(roleField);
    }
    const stampField = find(cfg.timestampField);
    if (stampField) {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      stampField.value = pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
      careers3Fire(stampField);
    }
  }

  document.addEventListener('click', (event) => {
    // Per-job form: Apply button reveals the form, then prefills it.
    const reveal = event.target.closest('[data-careers3-reveal]');
    if (reveal) {
      const inner = reveal.closest('.careers3-job__panel-inner');
      const form = inner && inner.querySelector('[data-careers3-form]');
      if (!form) return;
      form.hidden = false;
      reveal.hidden = true;
      careers3Prepare(reveal.closest('[data-section-type="careers3-jobs"]'), form);
      form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      form.querySelector('input:not([type=hidden]), select, textarea')?.focus({ preventScroll: true });
      return;
    }

    const link = event.target.closest('[data-careers3-apply]');
    if (!link) return;
    const section = link.closest('[data-section-type="careers3-jobs"]');
    const cfg = (section && section.dataset) || {};

    let target = null;
    if (cfg.scrollTarget) {
      target = careers3Query(document, cfg.scrollTarget);
    } else if (link.hash && link.origin === window.location.origin && link.pathname === window.location.pathname) {
      target = document.getElementById(link.hash.slice(1));
    }
    const { store, role } = link.dataset;
    careers3Fill(cfg, target || document, store, role, true);

    const note = (target || document).querySelector('[data-careers-role-note]');
    if (note) {
      note.textContent = role ? note.dataset.prefix + ' ' + role : '';
      note.hidden = !role;
    }

    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Count up numeric stat values when scrolled into view. Non-numeric values
    // (e.g. "P.J.Dip") have no digit match and are left untouched.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

    function animate(el) {
      var m = el.textContent.trim().match(/^(\D*?)([\d,]*\d)(\D*)$/);
      if (!m) return;
      var prefix = m[1];
      var suffix = m[3];
      var hasComma = m[2].indexOf(',') !== -1;
      var target = parseInt(m[2].replace(/,/g, ''), 10);
      if (isNaN(target)) return;
      var start = null;
      var dur = 1200;
      function fmt(n) { return hasComma ? n.toLocaleString('en-US') : String(n); }
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + fmt(Math.round(target * eased)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { animate(entries[i].target); io.unobserve(entries[i].target); }
      }
    }, { threshold: 0.4 });

    var vals = document.querySelectorAll('.careers-stats__value');
    for (var i = 0; i < vals.length; i++) io.observe(vals[i]);
  })();

  } catch(e) { console.error(e); }
})();
})();
